const errorMessages = {
    isRequired: (fieldName) => {
      return (fieldName + ' is required');
    },
    mustNotMatch: (fieldName, otherFieldName) => {
      return (otherFieldName + ' and ' + fieldName + ' cannot be same');
    },
    alpha: (fieldName) => {
      return (fieldName + ' cannot have numbers or special characters');
    },
    alphanumeric: (fieldName) => {
      return (fieldName + ' cannot have special characters');
    },
    futureDate: (fieldName) => {
      return (fieldName + ' cannot be a date of future');
    },
    pastDate: (fieldName) => {
      return (fieldName + ' must be a future date');
    },
    adultDOB: 'Adult\'s age must be greter than 12 years on the date of travel',
    childDOB: 'Child\'s age must be less than 12 years and greater than 2 years on the date of travel',
    infantDOB: 'Infant\'s age cannot be greater than 2 years on the date of travel',
    validEmail: 'Please enter a valid e-mail id',
    validContactNumber:'Please enter a valid mobile number',
    age:'age must be less than 99',
    srCitizenAge:'Age to be more than 60 for this category.',
    validMobileCode: () => {
      return 'Invalid Country Code';
    },
    invalidField: (fieldName) => {
      return ('Please enter a valid ' + fieldName);
    }
  };
  // const requiredName = (value, fieldName) => {
  //   if (value) return null;
  //   const error = errorMessages.isRequired(fieldName);
  //   return error;
  // };
  
  const required = (value, field, fieldName, id) => {
    if (value) return null;
    const error = {};
    error[id] = errorMessages.isRequired(fieldName);
    return error;
  };
  
  const mustNotMatch = (value, field, fieldName, id, otherField, otherFieldName, otherEleId, otherValue) => {
    if (value !== otherValue) return null;
    const error = {};
    error[id] = errorMessages.mustNotMatch(fieldName, otherFieldName);
    return error;
  };
  
  const alpha = (value, fieldName="name",msg) => {
      if(!value){
          return msg || errorMessages.isRequired(fieldName);
      }
    const regEx = /^[a-zA-Z -]+$/;
    if (regEx.test(value) || value === '') return null;
   return errorMessages.alpha(fieldName);
  };
  
  const alphanumeric = (value, fieldName,mandatory=true,msg) => {
    if(!value && required){
      return msg || errorMessages.isRequired(fieldName);
  }
    const regEx = /^[A-Za-z0-9]+$/;
    if (value === '' || regEx.test(value)) return null;
    
    return  errorMessages.alphanumeric(fieldName);
  };
  
  const validDate = (value, field, fieldName, id) => {
    if (value === '' || value === 'dd-mm-yyyy') return null;
    const dateArr = value.split('-');
    const date = new Date(dateArr[2], (parseInt(dateArr[1], 10) - 1), dateArr[0]);
    const error = {};
    error[id] = errorMessages.invalidField(fieldName);
    if (date.getFullYear() !== parseInt(dateArr[2], 10)) return error;
    if (date.getMonth() !== (parseInt(dateArr[1], 10) - 1)) return error;
    if (date.getDate() !== parseInt(dateArr[0], 10)) return error;
  };
  
  const futureDate = (value, field, fieldName, id) => {
    if (value === '' || value === 'dd-mm-yyyy') return null;
    const today = new Date();
    const dateArr = value.split('-');
    const date = new Date(dateArr[2], (parseInt(dateArr[1], 10) - 1), dateArr[0]);
    if ((today - date) > 0) return null;
    const error = {};
    error[id] = errorMessages.futureDate(fieldName);
    return error;
  };
  
  const pastDate = (value, field, fieldName, id) => {
    if (value === '' || value === 'dd-mm-yyyy') return null;
    const today = new Date();
    const dateArr = value.split('-');
    const date = new Date(dateArr[2], (parseInt(dateArr[1], 10) - 1), dateArr[0]);
    if ((today - date) < 0) return null;
    const error = {};
    error[id] = errorMessages.pastDate(fieldName);
    return error;
  };
  const age = (value,mandatory=true,msg) => {
    if(!value && mandatory){
      return msg;  
    }
  if (value >= 1 && value <= 99) return null;
  return errorMessages.age;
};
const srCitizenAge = (value,mandatory=true,msg) => {
  if(!value && mandatory){
    return msg;  
  }
if (value >= 60 && value <= 99) return null;
return errorMessages.srCitizenAge;
};
  const adultDOB = (value, otherValue= new Date(),fieldName="age",mandatory=true) => {
      if(!value && mandatory){
        return errorMessages.isRequired(fieldName);  
      }
    if (value === '' || value === 'dd-mm-yyyy') return null;
    const today = otherValue;
    const dateArr = value.split('-');
    const date = new Date(dateArr[2], (parseInt(dateArr[1], 10) - 1), dateArr[0]);
    const diff = ((today.getTime() - date.getTime()) / (365.25 * 24 * 60 * 60 * 1000));
    if (diff >= 12) return null;
    return errorMessages.adultDOB;
  };
  
  const childDOB = (value, field, fieldName, id, otherField, otherFieldName, otherEleId, otherValue) => {
    if (value === '' || value === 'dd-mm-yyyy') return null;
    const today = otherValue;
    const dateArr = value.split('-');
    const date = new Date(dateArr[2], (parseInt(dateArr[1], 10) - 1), dateArr[0]);
    const diff = ((today.getTime() - date.getTime()) / (365.25 * 24 * 60 * 60 * 1000));
    if (diff >= 2 && diff < 12) return null;
    const error = {};
    error[id] = errorMessages.childDOB;
    return error;
  };
  
  const infantDOB = (value, field, fieldName, id, otherField, otherFieldName, otherEleId, otherValue) => {
    if (value === '' || value === 'dd-mm-yyyy') return null;
    const today = otherValue;
    const dateArr = value.split('-');
    const date = new Date(dateArr[2], (parseInt(dateArr[1], 10) - 1), dateArr[0]);
    const diff = ((today.getTime() - date.getTime()) / (365.25 * 24 * 60 * 60 * 1000));
    if (diff < 2) return null;
    const error = {};
    error[id] = errorMessages.infantDOB;
    return error;
  };
  
  const validEmail = (value,fieldName='e-mail',mandatory=true,msg) => {
      if(!value && mandatory){
       return msg||  errorMessages.isRequired(fieldName)
      }
    const regEx = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (value === '' || regEx.test(value)) return null;
    return errorMessages.validEmail;
  };
  
  const validMobileNumber = (value, countryCode,fieldName='Mobile Number',mandatory=true,msg) => {
    if(!value && mandatory){
        return  msg || errorMessages.isRequired(fieldName)
       }
     
    const regEx = /^[0-9]+$/;
    /*  Check if the length of the mobile number is 10 for India (+91) and for others the length lies between 4 and 15 */
    if (value === '' || regEx.test(value) && ((countryCode === '+91' && value.length === 10) || (countryCode !== '+91' && value.length > 3 && value.length < 16))) {
      return null;
    }
   return  errorMessages.validContactNumber;
  };
  
  const validGSTNumber = (value, fieldName,mandatory=true,msg) => {
    if(!value && mandatory){
      return msg || errorMessages.isRequired(fieldName)
     }
 
    const regEx = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
    if (value === '' || regEx.test(value) && value.length === 15) return null;
  
  return errorMessages.invalidField(fieldName);
  };
  
  const validMobileCode = (value, field, fieldName, id) => {
    
    const regEx = /^(\+?\d{1,4})$/;
    if (regEx.test(value)) {
      return null;
    }
    const error = {};
    error[id] = errorMessages.validMobileCode(fieldName);
    return error;
  };
  
  const gst_business_email = (value, fieldName, mandatory=true,msg) => {
    if(!value && mandatory){
      return  msg || errorMessages.isRequired(fieldName)
     }
 
    const regEx = /^(([^\\^`~$|!%<>()[\]\\.,;:\s@\"]+(\.[^\\^`~$|!%<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (regEx.test(value)) {
      return null;
    }
    return errorMessages.invalidField(fieldName);
  };
  
  const validGSTMobile = (value, field, fieldName, id) => {
    const regEx = /^[1-9]{1}[0-9]{9}$/;
    if (regEx.test(value)) {
      return null;
    }
    const error = {};
    error[id] = errorMessages.invalidField(fieldName);
    return error;
  };
  const validGender = (value,fieldName="gender",mandatory=true) => {
      if(!value && mandatory){
          return errorMessages.isRequired(fieldName);
      }
    return null;
  };
  export const validations = {
    'required': required,
    'mustNotMatch': mustNotMatch,
    'alpha': alpha,
    'alphanumeric': alphanumeric,
    'validDate': validDate,
    'futureDate': futureDate,
    'pastDate': pastDate,
    'adultDOB': adultDOB,
    'childDOB': childDOB,
    'infantDOB': infantDOB,
    'validEmail': validEmail,
    'validMobileNumber': validMobileNumber,
    'validGSTNumber': validGSTNumber,
    'validMobileCode': validMobileCode,
    'gst_business_email': gst_business_email,
    'validGSTMobile': validGSTMobile,
    'validGender':validGender,
    'age':age,
    'srCitizenAge':srCitizenAge
  };
  